export default { sha: '123df0eae8512b7081bb84feefb8c28ee2f4edb1', buildNumber: 'undefined' }
